import { SortOrder } from '@creditflowresearch/uilib/Table/DataTable/interfaces/SortOrder';

export const initialArticleTilesCollectionFiltersState = {
  search: '',
  sortBy: 'publishedAt',
  sortOrder: 'desc' as SortOrder,
  page: 1,
  perPage: 10,
};

export const initialArticleTilesFiltersState = {
  filter: {},
  isExtended: false,
};

export const initialArticleTilesData = {
  collection: [],
  totalCount: 0,
  payload: initialArticleTilesFiltersState,
};
